export const L10N = {
  NOTIFICATION_ERROR_OPENPAY: { id: 'core.notification.error_openpay' },
};
